import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-99e70a54"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "info" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "东数西算", -1 /* HOISTED */))
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "2021年，我国启动全国一体化算力网络国家枢纽节点建设，加快推进“东数西算”工程，", -1 /* HOISTED */))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "旨在利用西部的气候、土地、电力资源优势充分节省数据计算的成本，争取于2025年底将超大型数据中心PUE降到1.3以下。", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_typography_paragraph = _resolveComponent("a-typography-paragraph")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_PlanInfoMap = _resolveComponent("PlanInfoMap")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_typography_title, { level: 1 }, {
        default: _withCtx(() => [
          _hoisted_3,
          (_ctx.$Store.Public().isGridMatch('>=',_ctx.$Enum.GridEnum.MD))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode("，")
              ], 64 /* STABLE_FRAGMENT */))
            : (_openBlock(), _createElementBlock("br", _hoisted_4)),
          _createTextVNode(" 大幅降低企业数字化运营成本 ")
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_a_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, {
            span: 24,
            order: _ctx.$Store.Public().isGridMatch('>=',_ctx.$Enum.GridEnum.SM)?1:2
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_typography_paragraph, null, {
                default: _withCtx(() => [
                  _hoisted_5,
                  (_ctx.$Store.Public().isGridMatch('>=',_ctx.$Enum.GridEnum.MD))
                    ? (_openBlock(), _createElementBlock("br", _hoisted_6))
                    : _createCommentVNode("v-if", true),
                  _hoisted_7
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_a_typography_title, { level: 5 }, {
                default: _withCtx(() => [
                  _createTextVNode(" 为了满足数据备份、数据容灾、降低数据存储成本等需要， 企业常常需要对数据进行复制、备份、迁移，因此数据迁移需求与场景激增。 ")
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["order"]),
          _createVNode(_component_a_col, {
            span: 24,
            order: _ctx.$Store.Public().isGridMatch('>=',_ctx.$Enum.GridEnum.SM)?2:1
          }, {
            default: _withCtx(() => [
              _createVNode(_component_PlanInfoMap)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["order"])
        ]),
        _: 1 /* STABLE */
      })
    ])
  ]))
}